// import Breadcrumbs from '@mui/material/Breadcrumbs';
// import Link from '@mui/material/Link';
import GlobalContext from 'contexts';
import { useContext, useEffect } from 'react';
import translating from '../../translate.json';
import logo from '../../assets/images/logo-well.png';
import usePostData from 'hooks/usePostData';

import './style.scss';

const Header = () => {
  const { currentUser } = useContext(GlobalContext);
  const { error, res, postData } = usePostData();

  useEffect(() => {
    if (res?.logout) location.href = '/login';
  }, [res, error]);

  const handleLogOut = () => {
    postData('auth/Logout', {});
  };

  return (
    <div className="header">
      <img className="logo" src={logo} alt="logo"></img>
      <div className="breadcrums">
        {/* <Breadcrumbs aria-label="breadcrumb">
        <Link underline="hover" color="inherit" href="/">
          MUI
        </Link>
        <Link
          underline="hover"
          color="inherit"
          href="/getting-started/installation/"
        >
          Core
        </Link>
      </Breadcrumbs> */}
      </div>
      {currentUser?.first_name && (
        <div className="user-box">
          {`${currentUser?.first_name} ${currentUser?.last_name} - `}
          <a onClick={handleLogOut}>{translating.logout}</a>
        </div>
      )}
    </div>
  );
};

export default Header;
